/**
 * Установка иконки MDI в ветку дерева
 * @param $dataType тип поля реестра
 * @return MDI иконка
 */
export const getFactorIcon = (dataType: string): string => {
    switch (dataType) {
        case 'numerator':
            return 'counter';
        case 'list':
            return 'format-list-bulleted';
        case 'address':
            return 'home-map-marker';
        case 'file':
            return 'text-box-multiple-outline';
        case 'gallery':
            return 'image-multiple';
        case 'relation':
            return 'link-variant';
        case 'access':
            return 'account-lock';
        case 'date':
            return 'calendar-range';
        case 'link':
            return 'web';
        case 'technical_process':
            return 'cogs';
        default:
            return 'file-document';
    }
};
